export default "__VITE_ASSET__C4ai0TJz__"